// TODO - I have no idea why Tristan wrote this this way, but I didn't change it.

var Jelly = {
    Jelly_Installation_Directory_Path: "/jelly",
    
	// Disable jquery's control of '$'
	// TODO: what happens if a user wants to use this or another $-based library
	// TODO: i feel like under the current system, we should really add $.noConflict immediately on load for Jquery, not here, doesn't belong here
	//jQuery: $.noConflict(),
	jQuery: $,
	
	// Register constants
	Namespace_Delimiter: "_",

	// Register installation directory
	Jelly_Installation_Directory_Path: "/jelly",

	// Register default path
	Default_Path: '',

	// Initalize instance variables.
	// TODO: do these belong here? I think so, but not certain.
	Body_Element: null,
	Current_Path: null,
	Directory: null,

	// Override context menu for super users
	Show_Context_Menu: false,

	Watch_Address_Bar_Interval: null
};

// TODO - where to put?
// jQuery fix
Jelly.jQuery.expr[':'].icontains = Jelly.jQuery.expr.createPseudo(function(text) {
	return function(e) {
		return $(e).text().toUpperCase().indexOf(text.toUpperCase()) >= 0;
	};
});